<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="商家" prop="merchantId">
                <a-select v-model="queryParam.merchantId" :maxLength="32" :placeholder="$t('请选择')+'店铺'" allow-clear>
                  <a-select-option v-for="item in merchantList" :key="item.id">{{ item.merchantName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('车辆名称')" prop="name">
                <a-input v-model="queryParam.name" :maxLength="32" :placeholder="$t('请输入')+$t('车辆名称')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('最大容积')" prop="maxVolume">
                <a-input v-model="queryParam.maxVolume" oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,3})?.*$/, '$1')" :maxLength="32" :placeholder="$t('请输入')+$t('最大容积')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('最大承重')" prop="maxWeight">
                <a-input v-model="queryParam.maxWeight" oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,3})?.*$/, '$1')" :maxLength="32" :placeholder="$t('请输入')+$t('最大承重')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('起步价')" prop="startPrice">
                <a-input v-model="queryParam.startPrice" oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,3})?.*$/, '$1')" :maxLength="32" :placeholder="$t('请输入')+$t('起步价')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('起步公里数')" prop="startKm">
                <a-input v-model="queryParam.startKm" oninput="value=value.replace(/[^\d]/g,'')" :maxLength="9" :placeholder="$t('请输入')+$t('起步公里数')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('每公里单价')" prop="kmPrice">
                <a-input v-model="queryParam.kmPrice" oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,3})?.*$/, '$1')" :maxLength="32" :placeholder="$t('请输入')+$t('每公里单价')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                   :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                   valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                   :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                   valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['shipping:templatevehicle:add']">
          <a-icon type="plus" />{{$t('新增')}}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['shipping:templatevehicle:edit']">
          <a-icon type="edit" />{{$t('修改')}}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['shipping:templatevehicle:remove']">
          <a-icon type="delete" />{{$t('删除')}}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['shipping:templatevehicle:export']">
          <a-icon type="download" />{{$t('导出')}}
        </a-button>
        <a-button type="primary" @click="$refs.importExcel.importExcelHandleOpen()" v-hasPermi="['shipping:templatevehicle:add']">
          <a-icon type="import" />{{ $t('导入') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <import-excel ref="importExcel" @ok="getList" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="status" slot-scope="text, record" >
          <a-switch  @change="(checked) => onStatusChange(checked,record)" checked-children="启用" un-checked-children="禁用" :checked="record.status"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['shipping:templatevehicle:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['shipping:templatevehicle:edit']">
             <a-icon type="edit" />{{$t('修改')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['shipping:templatevehicle:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['shipping:templatevehicle:remove']">
            <a-icon type="delete" />{{$t('删除')}}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageShippingTemplateVehicle,updateShippingTemplateVehicle, delShippingTemplateVehicle, } from '@/api/goods/shippingTemplateVehicle'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import ImportExcel from "./modules/ImportExcel.vue";
import {listSelectMerchant} from "@/api/merchant/merchantMerchant";

export default {
  name: 'ShippingTemplateVehicle',
  components: {
    CustomDictTag,
    ImportExcel,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      merchantList:[],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        merchantId:undefined,
        name: undefined,
        maxVolume: undefined,
        maxWeight: undefined,
        startPrice: undefined,
        startKm: undefined,
        kmPrice: undefined,
        status: undefined,
        sort: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('车辆名称'),
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('最大容积'),
          dataIndex: 'maxVolume',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('最大承重'),
          dataIndex: 'maxWeight',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('起步价'),
          dataIndex: 'startPrice',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('起步公里数'),
          dataIndex: 'startKm',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('每公里单价'),
          dataIndex: 'kmPrice',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('状态'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('排序'),
          dataIndex: 'sort',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '所属组织',
          dataIndex: 'deptName',
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '12%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
    this.getMerchantList()
  },
  computed: {
    ...mapGetters(['customDict','userInfo'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询车辆运费列表 */
    getList () {
      this.loading = true
     pageShippingTemplateVehicle(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    getMerchantList () {
      listSelectMerchant({}).then(response => {
        this.merchantList = response.data
        if (this.userInfo.deptType !== 2) {
          //添加一条记录,放到首位
          this.merchantList.unshift({"id": 0,"merchantName":'平台'})
        }
      })
    },
    onStatusChange(checked, record) {
      let data = {id:record.id, status: checked}
      updateShippingTemplateVehicle(data).then(response => {
        if (response.success) {
          this.$message.success(
            this.$t('修改成功'),
            3
          );
          this.$emit('ok')
          record.status=checked
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        merchantId:undefined,
        name: undefined,
        maxVolume: undefined,
        maxWeight: undefined,
        startPrice: undefined,
        startKm: undefined,
        kmPrice: undefined,
        status: undefined,
        sort: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delShippingTemplateVehicle(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(
                message,
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('biz/admin/shipping/template/vehicle/export',
            that.queryParam
          , `车辆运费_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
